import React from "react";

const ChallengeItem = ({ title, description, isLast = false }) => (
  <div className="flex relative pl-8 pb-20"> 
    <div className="absolute left-0 top-[13px] bottom-0 w-2">
      <div className="absolute top-0 w-2 h-2 bg-white border border-white"></div>
      {!isLast && (
        <div 
          className="absolute left-[3.5px] top-[8px] w-px bg-gray-400" 
          style={{ height: 'calc(100% - 0px)' }} 
        ></div>
      )}
    </div>
    <div className="flex-grow">
      <p 
        className="
          text-white mb-1 w-full {/* Changed to text-white */}
          font-uber text-[18px] font-medium leading-normal
          transition duration-200 ease-in-out
        "
      >
        {title}
      </p>
      <p 
        className="
          text-gray-300 {/* Changed to a light gray */}
          font-uber text-base font-normal leading-normal
        "
      >
        {description}
      </p>
    </div>
  </div>
);


export default function Takeaways() {
  return (
    <section className="relative w-full overflow-hidden"> 
      
      <img
        src="/uploads/CaseStudy/Keytakeaways bg.svg"
        alt="Key Takeaways Background"
        className="absolute inset-0 w-full h-full object-cover z-0 pointer-events-none"
      />

      <div className="mx-auto max-w-6xl py-12 px-4 sm:px-4 relative z-10"> 
        
        <div className="flex flex-col xl-custom:flex-row mb-4">
            <div className="w-full xl-custom:w-1/2 hidden xl-custom:block"></div>
            <div className="w-full xl-custom:w-1/2 xl-custom:text-left xl-custom:pl-8">
              <h2 
                className="
                  w-full
                  font-uber text-[28px] font-bold leading-[36px] text-white
                  sm:text-[32px] sm:leading-[40px]
                  xl-custom:text-[36px] xl-custom:leading-[44px]
                  transition duration-200 ease-in-out
                "
              >
                Key Takeaways
              </h2>
            </div>
        </div>

        <div className="flex flex-col xl-custom:flex-row gap-12 xl-custom:items-start">
          
          <div className="w-full xl-custom:w-1/2 flex items-start xl-custom:justify-start order-1 xl-custom:order-1">
            <div className="w-full xl-custom:w-5/6 rounded-lg p-4 sm:p-8"> 
                <img
                src="/uploads/CaseStudy/Asset 95.svg"
                className="w-full" 
                alt="Customer feedback visualization placeholder" />
            </div>
          </div>
          
          <div className="w-full xl-custom:w-1/2 order-2 xl-custom:order-2">
            
            <ChallengeItem title="Gamification enhances user engagement and improves conversion rate" description="" />
            <ChallengeItem title="Personalization plays a crucial role in driving customer satisfaction" description="" />
            <ChallengeItem title="Seamless responsiveness in user experience across multiple devices is essential for maximizing impact" description="" />
            <ChallengeItem title="Regular data insights help refine and optimize playable experiences for better engagement" isLast={true} description="" />
            
          </div>
          
        </div>
      </div>
    </section>
  );
}